import React from 'react';
import { useDispatch } from 'react-redux';
import { setDrawerOpen } from 'features/ui/model/uiSlice';
import { SubmitHandler, useForm } from 'react-hook-form';
import { DefaultValueDrawerBannerType } from 'entities/banner/types';
import { useCreateBannerCardDefaultValues } from 'entities/banner/lib/hooks';
import { useCreateBannerMutation } from 'entities/banner/api';
import { BannerCard } from './BannerCard';

export const CreateBannerCard = () => {
  const dispatch = useDispatch();
  const [createBanner] = useCreateBannerMutation();
  const defaultValues = useCreateBannerCardDefaultValues();

  const createBannerForm = useForm<Partial<DefaultValueDrawerBannerType>>({
    defaultValues,
  });

  const onSubmit: SubmitHandler<Partial<DefaultValueDrawerBannerType>> = (data) => {
    createBanner(data).then(() => {
      dispatch(setDrawerOpen(false));
    });
  };

  // @ts-ignore TODO refactor
  return (
    <BannerCard
      title="Создать баннер"
      form={createBannerForm}
      onSubmit={onSubmit}
    />
  );
};
